const Logo = require('../../../assets/logo.png');
const GithubLogo = require('../../../assets/github.png');

export const LINKS_FOOTER = [
  {
    name: 'Vlad Stepanov',
    link: 'https://github.com/wlladislaw/',
    img: `${GithubLogo}`,
    id: 1,
  },
  {
    name: 'Mikhail Matveichuk',
    link: 'https://github.com/MihailMatveichuk/',
    img: `${GithubLogo}`,
    id: 2,
  },
  {
    name: 'Valery Ryzhkou',
    link: 'https://github.com/ValeryRyzhkou',
    img: `${GithubLogo}`,
    id: 3,
  },
  {
    name: 'RSS School',
    link: 'https://rs.school/js/',
    img: `${Logo}`,
    id: 4,
  },
];
